<template>
  <div id="container">
    <el-container>
      <el-header>
        <span style="font-size: larger;font-weight: 600;">考勤打卡</span>
      </el-header>
      <el-main>
        <el-row>
          <el-input v-model="mobileOrId" @input="changeInput" placeholder="输入身份证或者手机号"></el-input>
          <br />
          <el-steps direction="vertical" :active="2" space="200px" style="margin-top:10px;">
            <el-step :title="`上班时间${workStart.split(':')[0]+':'+workStart.split(':')[1]}`">
              <template slot="description">
                <el-button
                  v-if="showButton1"
                  @click="daka(0)"
                  :style="{backgroundColor:'#409EFF',display: 'inline-block',borderRadius:'50%',width:'150px',height:'150px',color:'black',fontSize:'20px',textAlign: 'center',mrginTop:'50px',}"
                >
                  <span style="line-height: 100px;">{{dakaInfo1}}</span>
                  <br />
                  <span>{{nowTime}}</span>
                </el-button>
                <span v-else>
                  打卡时间: {{dakaTime1}}
                  <br />
                  {{dakaInfo1}}
                </span>
              </template>
            </el-step>
            <el-step :title="`下班时间${workEnd.split(':')[0]+':'+workEnd.split(':')[1]}`">
              <template slot="description">
                <el-button
                  v-if="showButton2"
                  @click="daka(1)"
                  :style="{backgroundColor:'#409EFF',display: 'inline-block',marginLeft:'-10%',borderRadius:'50%',width:'150px',height:'150px',color:'black',fontSize:'20px',textAlign: 'center',mrginTop:'50px',}"
                >
                  <span style="line-height: 100px;">{{dakaInfo2}}</span>
                  <br />
                  <span>{{nowTime}}</span>
                </el-button>
                <span v-else>
                  打卡时间: {{dakaTime2}}
                  <br />
                  {{dakaInfo2}}
                </span>
              </template>
            </el-step>
          </el-steps>
          <!-- <center></center> -->
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import lk from "@/api/lk";
import G from "@/views/common/global";
export default {
  data() {
    return {
      nowTime: "",
      mobileOrId: "",
      dakaInfo1: "",
      dakaInfo2: "",
      showButton1: true,
      showButton2: true,
      dakaTime1: "",
      dakaTime2: "",
      workStart: '',
      workEnd: ''
    };
  },
  created() {
    setInterval(() => {
      let time = new Date();
      this.nowTime =
        time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds();
    }, 1000);
    this.getButtonInfo();
    if (
      typeof localStorage.getItem("mobileOrId") != "undefined" &&
      localStorage.getItem("mobileOrId") != "null"
    ) {
      this.mobileOrId = localStorage.getItem("mobileOrId");
    }
  },
  mounted() {
    this.getUserNowDayAttendance();
  },
  methods: {
    getButtonInfo() {
      lk.getWorkTime().then(res => {
        this.workStart =res.data.c_start
        this.workEnd = res.data.c_end
        let myTime = new Date();
        if ((myTime.getHours() < parseInt(this.workStart.split(':')[0]) || (myTime.getHours() == parseInt(this.workStart.split(':')[0])) && myTime.getMinutes() <= parseInt(this.workStart.split(':')[1])) && myTime.getHours() > 0) {
          this.dakaInfo1 = "上班打卡";
          this.dakaInfo2 = "";
          this.showButton1 = true;
          this.showButton2 = false;
        } else if ((myTime.getHours() > parseInt(this.workStart.split(':')[0]) || (myTime.getHours() == parseInt(this.workStart.split(':')[0]) && myTime.getMinutes() > parseInt(this.workStart.split(':')[1]))) && myTime.getHours() <= 12) {
          this.dakaInfo1 = "迟到打卡";
          this.dakaInfo2 = "";
          this.showButton1 = true;
          this.showButton2 = false;
        } else if (myTime.getHours() > 12 && (myTime.getHours() < parseInt(this.workEnd.split(':')[0]) || (myTime.getHours() == parseInt(this.workEnd.split(':')[0]) && myTime.getMinutes() < parseInt(this.workEnd.split(':')[1])))) {
          this.dakaInfo1 = "";
          this.dakaInfo2 = "早退打卡";
          this.showButton1 = false;
          this.showButton2 = true;
        } else if ((myTime.getHours() > parseInt(this.workEnd.split(':')[0]) || (myTime.getHours() == parseInt(this.workEnd.split(':')[0]) && myTime.getMinutes() >= parseInt(this.workEnd.split(':')[1]))) && myTime.getHours() < 24) {
          this.dakaInfo1 = "";
          this.dakaInfo2 = "下班打卡";
          this.showButton1 = false;
          this.showButton2 = true;
        }else{
            console.log('error')
        }
      });
    },
    changeInput() {
      if (
        G.REG.MOBILE.test(this.mobileOrId) ||
        G.REG.ID_CARD.test(this.mobileOrId)
      ) {
        this.getUserNowDayAttendance();
      } else {
        this.getButtonInfo();
      }
    },
    getUserNowDayAttendance() {
      if (this.mobileOrId != null && this.mobileOrId.trim() != "") {
        lk.getUserNowDayAttendance({ text: this.mobileOrId }).then(res => {
          if (res.code == 200) {
            res.data.forEach(element => {
              if (element.c_type == 0) {
                this.showButton1 = false;
                this.dakaInfo1 = element.c_desc;
                this.dakaTime1 = element.c_clock;
              } else {
                this.showButton2 = false;
                this.dakaInfo2 = element.c_desc;
                this.dakaTime2 = element.c_clock;
              }
            });
          }
        });
      }
    },
    daka(index) {
      this.getUserNowDayAttendance();
      localStorage.setItem("mobileOrId", this.mobileOrId);
      let date = new Date();
      if (this.mobileOrId == null || this.mobileOrId.trim() == "") {
        this.$notify.error("请填写身份证或手机号");
        return;
      }
      lk.addAttendance({
        source_user_mobile: this.mobileOrId,
        c_clock:
          date.getFullYear() +
          "-" +
          (date.getMonth() + 1) +
          "-" +
          date.getDate() +
          " " +
          this.nowTime,
        c_type: index,
        c_desc: index == 0 ? this.dakaInfo1 : this.dakaInfo2
      }).then(res => {
        if (res.code == 200) {
          if (index == 0) {
            this.showButton1 = false;
          } else {
            this.showButton2 = false;
          }
          this.getUserNowDayAttendance();
        } else {
          this.$notify.error(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-header {
  color: #333;
  text-align: center;
  line-height: 60px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
/deep/ .el-step__description {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/source/mobileScan.vue